module.exports = __webpack_public_path__ + "static/media/satBad.1608e1e3.png";